
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conference/champion",
      function () {
        return require("private-next-pages/conference/champion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conference/champion"])
      });
    }
  